export enum MonitoringModeEnum {
    DAY = "Day",
    NIGHT = "Night"
}
